
































































import {Vue, Component, VModel} from 'vue-property-decorator';
import RightSideBar from "@/components/payroll/business/services/RightSideBar.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import ContactCreationSlider from "@/components/payroll/business/services/contact/ContactCreationSlider.vue";
import {
	InvoiceContact,
	InvoiceContactFilter,
} from "@/components/payroll/business/services/ServiceDTO";
import {processError} from "@/utils/ComponentUtils";
import Page, {EMPTY_PAGE} from "@/dto/taxation/Page";
import Application from "@/state/Application";
import ServiceLogOrchestrator from "@/services/ServiceLogOrchestrator";

@Component({
	components: {
		ContactCreationSlider,
		PortalInput,
		RightSideBar
	}
})
export default class RefContactSliderSelector extends Vue {

	@VModel({type: Boolean, default: false})
	private model!: boolean

	private search: string | null = null
	private createContact = false

	private filter: InvoiceContactFilter = new InvoiceContactFilter(
		{
			createdBy: this.$wss.getCurrent.id,
			searchMode: "REF"
		}
	)

	private recentContacts: Array<InvoiceContact> = []
	private allContacts: Page<InvoiceContact> = EMPTY_PAGE

	public mount(visible: boolean): void {
		if (visible) {
			Application.startLoading()
			this.loadRecentContacts()
				.then(this.loadInvoiceContactPageByFilter)
				.finally(Application.stopLoading)
		}
	}

	private loadRecentContacts() {
		return ServiceLogOrchestrator.getRecentContactsByFilter(this.$wss.getCurrent.id).then(
			res => {
				this.recentContacts = res.data;
			},
			err => processError(err, this)
		)
	}

	private loadInvoiceContactPageByFilter() {
		return ServiceLogOrchestrator.getContactsByFilter(this.filter).then(
			res => {
				this.allContacts = res.data
			},
			err => processError(err, this)
		)
	}

	private create(contact: InvoiceContact) {
		this.recentContacts = [contact, ...this.recentContacts]
		this.allContacts.content = [contact, ...this.allContacts.content]
		this.selectContact(contact)
	}

	private selectContact(contact: InvoiceContact): void {
		this.$emit("selected", contact)
		this.$emit("input", false)
	}

	private selectProfile() {
		this.$emit("selected", new InvoiceContact(
			{
				id: this.$wss.getCurrent.id,
				name: this.$wss.getCurrent.name,
				refUserId: this.$wss.getCurrent.userId,
				email: ""
			}
		))
		this.$emit("input", false)
	}

}
